module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transitionName
    },
    on: {
      "enter": _vm.handleEnter,
      "leave": _vm.handleLeave
    }
  }, [_c('div', {
    class: _vm.classes,
    style: (_vm.styles)
  }, [(_vm.type === 'notice') ? [_c('div', {
    ref: "content",
    class: _vm.contentClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.contentWithIcon
  }, [_c('render-cell', {
    attrs: {
      "render": _vm.renderFunc
    }
  })], 1), _vm._v(" "), (_vm.closable) ? _c('a', {
    class: [_vm.baseClass + '-close'],
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-close-empty"
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.type === 'message') ? [_c('div', {
    ref: "content",
    class: [_vm.baseClass + '-content']
  }, [_c('div', {
    class: [_vm.baseClass + '-content-text'],
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.baseClass + '-content-text']
  }, [_c('render-cell', {
    attrs: {
      "render": _vm.renderFunc
    }
  })], 1), _vm._v(" "), (_vm.closable) ? _c('a', {
    class: [_vm.baseClass + '-close'],
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-close-empty"
  })]) : _vm._e()])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-578ad29e!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./~/_iview@2.14.3@iview/src/components/base/notification/notice.vue
// module id = 307
// module chunks = 99 101